var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",style:({ height: _vm.height })},[_c('div',{staticClass:"custom-spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }